import styled from "styled-components";
import { Box } from "@mui/material";
import { Congiguration } from "../../../Constants/AppConstants";
export const BreadcrumbBox = styled(Box)`
ol{
    padding: 10px 30px;
    
    li{
        color: #fff;
        a{
            text-decoration: none;
            cursor: pointer;
            font-family: 'Noto Sans', sans-serif;
        }

        p{
            color: #fff;
            font-weight: 600;  
            font-family: 'Noto Sans', sans-serif;
        }
    }
 }
`;